import React from "react";
import styles from "./details.module.css";
import Navbar from "../../Components/Navbar/Navbar";
import { Col, Container, Row } from "react-bootstrap";
import {
  Heading,
  Paragraph,
} from "../../Components/TextComponents/TextComponents";
import Objectives from "../../Components/Objectives/Objectives";

const ProjectDetails = () => {
  return (
    <React.Fragment>
      <div className={styles.main_section}>
        <Navbar />

        <Container>
          <Row>
            <Col md={6} sm={12}>
              <div className={styles.heroSection}>
                <Heading color="#fff">
                  Transforming Gujarat’s Energy Landscape
                </Heading>
                <Paragraph color="#fff">
                  Empowering government infrastructure with clean, renewable
                  energy solutions.
                </Paragraph>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className={styles.section}>
        {/* ---------section---------- */}
        <Container className="my-5">
          <Row>
            <Col md={6} sm={12}>
              <Heading>Project Overview</Heading>
              <Paragraph color="#62677A">
                Here are some of our most notable accomplishments that highlight
                our expertise and dedication to excellence.
              </Paragraph>
            </Col>
            <Col md={6} sm={12}>
              <Paragraph>
                In a groundbreaking initiative, CrossBorder BTC partnered with
                regional authorities in Gujarat to install a 48 MW solar rooftop
                system across government buildings. This project aimed to reduce
                the carbon footprint, promote renewable energy adoption, and
                lower electricity costs for public infrastructure.
              </Paragraph>
            </Col>
          </Row>
          <img loading="lazy" src="/images/project/farming.png" alt="" />
        </Container>
      </div>

      {/* ---------highlights-section-start------------ */}
      <Container>
        <div className={styles.highlights_section}>
          <Heading>Highlights:</Heading>
          <div className={styles.values}>
            <div>
              <h6>Gujarat</h6>
              <p>Project Location</p>
            </div>
            <div>
              <h6>2025</h6>
              <p>Completion Date</p>
            </div>
            <div>
              <h6>India Govt</h6>
              <p>Client</p>
            </div>
            <div>
              <h6>Renewable Energy</h6>
              <p>Category</p>
            </div>
          </div>
        </div>
      </Container>
      {/* ---------highlights-section-end------------ */}

      <Objectives />
    </React.Fragment>
  );
};

export default ProjectDetails;
